import { render } from "./ModalError.vue?vue&type=template&id=b5b32e04&scoped=true"
import script from "./ModalError.vue?vue&type=script&lang=js"
export * from "./ModalError.vue?vue&type=script&lang=js"

import "./ModalError.vue?vue&type=style&index=0&id=b5b32e04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5b32e04"]])

export default __exports__